<div class="container pt-5 pt-xl-6">
    <div class="row">
        <div class="col-lg-6">
            <div class="background-pink px-4 py-2 speech-bubble" appAos>
                <span class="fw-bold color-white">{{body()?.primary?.title?.[0]?.text}}</span>
            </div>
        </div>
    </div>
</div>
